import React from 'react'

interface InputCharacterCounterProps {
    inputCharLength: number
    maxInputLength: number
}

const InputCharacterCounter: React.FC<InputCharacterCounterProps> = ({ inputCharLength, maxInputLength }) => {
    const isMaxLengthExceed = inputCharLength > maxInputLength
    return (
        <>
            <div className={isMaxLengthExceed ? 'error' : ''}>{inputCharLength}</div>/{maxInputLength}
        </>
    )
}
export default InputCharacterCounter
